<template>
  <div id="list">
    <div class="row">
      <div class="col-12">
        <h4 class="font-weight-bold">Listado general de PQRs</h4>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="keyword">Búsqueda rápida de pqrs</label>
          <input type="text" class="form-control" placeholder="Busque por estado, tipo, responsable..." v-model.trim="keyword">
        </div>
      </div>
      <div class="col-12 col-lg-6 d-lg-flex align-items-center justify-content-lg-end">
        <span class="text-muted">Mostrando {{pqrs.length}} resultados.</span>
      </div>
      <div class="col-12 mt-3">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Estado</th>
                <th>Tipo</th>
                <th>Solicitante</th>
                <th>Responsable</th>
                <th>Fecha de asignación</th>
                <th>Fecha de cierre</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!results.length">
                <td colspan="6">No se encontraron resultados.</td>
              </tr>
              <tr v-for="(pqr, index) in results"
              v-bind:key="index">
                <td>
                  <h5 class="m-0">
                    <span class="badge text-capitalize"
                      v-bind:class="{
                        'badge-warning': pqr.status == 'pendiente',
                        'badge-success': pqr.status == 'en proceso',
                        'badge-danger': pqr.status == 'cerrado',
                      }">
                      {{pqr.status}}
                    </span>
                  </h5>
                </td>
                <td>
                  <h5 class="m-0">
                    <span class="badge text-capitalize"
                      v-bind:class="{
                        'badge-info': pqr.type == 'peticion',
                        'badge-primary': pqr.type == 'queja',
                        'badge-warning': pqr.type == 'reclamo',
                        'badge-danger': pqr.type == 'denuncia',
                      }">
                      {{pqr.type}}
                    </span>
                  </h5>
                </td>
                <td>{{pqr.user.name}}</td>
                <td>
                  {{pqr.official || "---" }}
                </td>
                <td>{{pqr.assignmentDate | date}}</td>
                <td>{{pqr.deadline | date}}</td>
                <td>
                  <a href="javascript:;"
                    class="text-primary mr-3"
                    v-on:click.prevent="handleUpdate(pqr.id)">
                    Ver / Modificar
                  </a>
                  <a href="javascript:;"
                    class="text-danger mr-3"
                    v-on:click.prevent="handleDelete(pqr.id)">
                    Eliminar
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firestore, } from "@/firebase";
  export default {
    data() {
      return {
        pqrs: [],
        keyword: "",
      };
    },
    computed: {
      results() {
        return this.pqrs.filter(pqr => pqr.type.trim().toLowerCase().includes(this.keyword.toLowerCase())
          || pqr.status.trim().toLowerCase().includes(this.keyword.toLowerCase())
          || pqr.official.trim().toLowerCase().includes(this.keyword.toLowerCase())
        );
      },
    },
    methods: {
      async getPqrs() {
        this.pqrs = [];
        const snapshot = await firestore.collection("/pqrs").get();
        snapshot.forEach(async doc => {

          let official = "";

          if (doc.get("assignedTo")) {
            const user = await firestore.doc(`/users/${doc.get("assignedTo")}`).get();
            official = `${user.get("name")} ${user.get("lastName")}`;
          }

          this.pqrs.push({
            ...doc.data(),
            id: doc.id,
            official,
          });
        });
      },
      handleUpdate(id) {
        this.$store.commit("SET_EDIT_PQR", this.pqrs.find(a => a.id == id));
        this.$router.push({
          name: "UpdatePqr",
          params: { id, },
        });
      },
      async handleDelete(id) {
        const confirm = await this.$swal({
          title: "¿Seguro que deseas eliminar este pqr?",
          buttons: ["Cancelar", "Confirmar"],
        });
        if (confirm)
          try {
            await firestore.doc(`/pqrs/${id}`).delete();
            this.getPqrs();
            this.$swal("Operación exitosa", "Pqr eliminado con éxito", "success");
          } catch(e) {
            console.error(e);
            this.$swal("Error", e.toString(), "error");
          }
      },
    },
    created() {
      this.getPqrs();
    },
  };
</script>